export default "__VITE_PUBLIC_ASSET__2ab76730__"